import {FC, SVGProps} from 'react';
import type {TermsDocumentIcon} from '../../model/termsDocuments';

type IconProps = SVGProps<SVGSVGElement>;

const LockIcon: FC<IconProps> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16 4C19.866 4 23 7.13401 23 11V14H26V28H6V14H9V11C9 7.13401 12.134 4 16 4ZM16 19C14.8954 19 14 19.8954 14 21C14 22.1046 14.8954 23 16 23C17.1046 23 18 22.1046 18 21C18 19.8954 17.1046 19 16 19ZM16 7C13.7909 7 12 8.79086 12 11V14H20V11C20 8.79086 18.2091 7 16 7Z"
			fill="black"
		/>
	</svg>
);

const ShieldIcon: FC<IconProps> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M26 22L16 30L6 22V4H26V22ZM14.6143 15.627L11.6826 12.8711L10.998 13.5996L10.3135 14.3291L13.9297 17.7285L14.6152 18.3721L15.2998 17.7285L21.6826 11.7285L20.3135 10.2715L14.6143 15.627Z"
			fill="black"
		/>
	</svg>
);

const KeyIcon: FC<IconProps> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.3474 23.6526C16.3495 25.9079 21.516 25.3319 24.9233 21.9246C29.0238 17.8241 29.0238 11.1759 24.9233 7.07538C20.8228 2.97487 14.1745 2.97487 10.074 7.07538C6.66623 10.4832 6.09055 15.6507 8.34701 19.653L2.0005 26L2 30L6.0003 30V27H9.00052L12.3474 23.6526ZM19.9964 15C21.6533 15.0016 22.9977 13.6597 22.9993 12.0029C23.0009 10.346 21.659 9.00159 20.0022 9C18.3453 8.99841 17.0009 10.3403 16.9993 11.9971C16.9977 13.654 18.3396 14.9984 19.9964 15Z"
			fill="black"
		/>
	</svg>
);

const MaskIcon: FC<IconProps> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16 3C21.5228 3 26 7.47715 26 13V29H6V13C6 7.47715 10.4772 3 16 3ZM12.5 12C10.567 12 9 13.567 9 15.5C9 17.433 10.567 19 12.5 19H19.5C21.433 19 23 17.433 23 15.5C23 13.567 21.433 12 19.5 12H12.5ZM12.5 14C13.3284 14 14 14.6716 14 15.5C14 16.3284 13.3284 17 12.5 17C11.6716 17 11 16.3284 11 15.5C11 14.6716 11.6716 14 12.5 14ZM19.5 14C20.3284 14 21 14.6716 21 15.5C21 16.3284 20.3284 17 19.5 17C18.6716 17 18 16.3284 18 15.5C18 14.6716 18.6716 14 19.5 14Z"
			fill="black"
		/>
	</svg>
);

const ICONS: Record<TermsDocumentIcon, FC<IconProps>> = {
	lock: LockIcon,
	shield: ShieldIcon,
	key: KeyIcon,
	mask: MaskIcon,
};

export const TermsDocumentIconView: FC<{name: TermsDocumentIcon; className?: string}> = ({name, className}) => {
	const Icon = ICONS[name];
	return <Icon className={className} />;
};
